import type {ReactElement} from 'react';
import React from 'react';
import {ControlledList} from '@Components/controlled-list';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {isOpenCustomImageAndVideoRecorder} from '@Libraries/record-image-and-video.library';
import {openRecordImageAndVideoModal} from '@Modals/record-image-and-video-modal';
import {RecorderMediaType} from '@Panels/record-image-and-video-panel/record-image-and-video.types';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {AddItemThumbnail} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-thumbnail';
import {openRecordAudioModal} from '@Modals/record-audio-modal';
import {useHiddenImageAndVideoInput} from '@Hooks/poster-editor/useHiddenImageAndVideoInput';
import type {ElementData} from '@Libraries/add-media-library';
import {onAddItems} from '@Components/poster-editor/library/poster-editor-open-modals';
import type {AddItemDropdownProps} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';

export function RecordDropdownList({className = '', onOpenModal = (): void => {}}: AddItemDropdownProps): ReactElement<any> {
  const onAddRecordedItems = (item: ElementData): void => {
    onAddItems([item]);
  };

  const hiddenImageAndVideoInput = useHiddenImageAndVideoInput(onAddRecordedItems);

  const getRecordOptions = (): ReactElement<any> => {
    return (
      <ControlledList
        className={`spacing-m-0 ${className}`}
        items={[
          {
            id: 'capture-photo',
            type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
            text: window.i18next.t('pmwjs_photo'),
            subText: window.i18next.t('pwmjs_capture_photo_description'),
            onClick: (): void => {
              onOpenModal();
              isOpenCustomImageAndVideoRecorder()
                ? openRecordImageAndVideoModal({recorderOpenedWithMediaType: RecorderMediaType.IMAGE, onAddSelected: onAddRecordedItems})
                : hiddenImageAndVideoInput.handleHiddenInputTagClick(RecorderMediaType.IMAGE);
            },
            thumbnail: {
              type: ThumbnailType.CUSTOM,
              content: <AddItemThumbnail icon="icon-camera" />,
            },
          },
          {
            id: 'record-video',
            type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
            text: window.i18next.t('pmwjs_video'),
            subText: window.i18next.t('pwmjs_record_video_description'),
            onClick: (): void => {
              onOpenModal();
              isOpenCustomImageAndVideoRecorder()
                ? openRecordImageAndVideoModal({recorderOpenedWithMediaType: RecorderMediaType.VIDEO, onAddSelected: onAddRecordedItems})
                : hiddenImageAndVideoInput.handleHiddenInputTagClick(RecorderMediaType.VIDEO);
            },
            thumbnail: {
              type: ThumbnailType.CUSTOM,
              content: <AddItemThumbnail icon="icon-videocam" />,
            },
          },
          {
            id: 'record-audio',
            type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
            text: window.i18next.t('pmwjs_audio'),
            subText: window.i18next.t('pwmjs_record_audio_description'),
            onClick: (): void => {
              onOpenModal();
              openRecordAudioModal({
                onAddSelected: onAddRecordedItems,
              });
            },
            thumbnail: {
              type: ThumbnailType.CUSTOM,
              content: <AddItemThumbnail icon="icon-microphone" />,
            },
          },
        ]}
      />
    );
  };
  return getRecordOptions();
}
